import { CreateTicketOrderItemDto } from "./create-ticket-order-item.dto";
import { CreatePassOrderItemDto } from './create-pass-order-item.dto';

export class CreateTicketOrderDto {
  ticketOrderItems?: CreateTicketOrderItemDto[];
  passOrderItems?: CreatePassOrderItemDto[];
}
